// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPhoneInfoDto
 */
export interface IPhoneInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IPhoneInfoDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof IPhoneInfoDto
     */
    phone_type: IPhoneInfoDtoPhoneTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPhoneInfoDtoPhoneTypeEnum {
    WORK = 'WORK',
    HOME = 'HOME',
    UNKNOWN = 'UNKNOWN',
    MOBILE = 'MOBILE'
}


/**
 * Check if a given object implements the IPhoneInfoDto interface.
 */
export function instanceOfIPhoneInfoDto(value: object): value is IPhoneInfoDto {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('phone_type' in value) || value['phone_type'] === undefined) return false;
    return true;
}

export function IPhoneInfoDtoFromJSON(json: any): IPhoneInfoDto {
    return IPhoneInfoDtoFromJSONTyped(json, false);
}

export function IPhoneInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPhoneInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'phone_type': json['phone_type'],
    };
}

export function IPhoneInfoDtoToJSON(json: any): IPhoneInfoDto {
    return IPhoneInfoDtoToJSONTyped(json, false);
}

export function IPhoneInfoDtoToJSONTyped(value?: IPhoneInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'phone_type': value['phone_type'],
    };
}

